import { all } from "redux-saga/effects";
import {
  watchFetchAllUsers,
  watchFetchCourseData,
  watchFetchScormPackageData,
  watchFetchUsersAnalytics,
  watchMount,
  watchUnmount,
} from "./watchers";

export function* scormPackageAnalyticsSagas() {
  yield all([
    watchFetchAllUsers(),
    watchFetchCourseData(),
    watchFetchScormPackageData(),
    watchFetchUsersAnalytics(),
    watchMount(),
    watchUnmount(),
  ]);
}
